import React, { useState, useEffect } from 'react';
import API from '../../../Services/BaseService';
import { useHistory, useLocation, useParams } from "react-router-dom";
import CommonPopup from '../../../Component/CommonPopup/CommonPopup';
import "../../../Component/CommonPopup/commonPopup.css"
import { useDispatch, useSelector } from 'react-redux';
import ls from 'local-storage';
/* import { Button } from "antd"; */
import { Modal, Button } from 'react-bootstrap';

const ViewArb = (props) => {
    const history = useHistory();

    const [isCommonPopupOpen, setIsCommonPopupOpen] = useState(false);
    const [popupTitle, setPopupTitle] = useState("");
    const [popupMsg, setPopupMsg] = useState("");
    const [popupType, setPopupType] = useState("");
    const [popupActionType, setPopupActionType] = useState("");
    const [popupActionValue, setPopupActionValue] = useState("");
    const [popupActionPath, setPopupActionPath] = useState("");
    const [alertmessage, setAlertMessage] = useState("");
    const [alerttitle, setAlertTitle] = useState("");
    const [alertimg, setAlertImg] = useState("");
    const [commentsError, setCommentsError] = useState("");
    const adminData = useSelector(state => state.LoginReducer.payload);
    const [togglePopupOpen, setTogglePopupOpen] = useState(true);
    const [notesList, setNotesList] = useState("");
    const [comments, setComments] = useState();
    const [arb, setArb] = useState();
    const successData = useSelector(state => state.LoginReducer.payload);


    const toggleCommonPopup = () => {
        setIsCommonPopupOpen(!isCommonPopupOpen);
    }

    const viewRegistration = () => {
        let request = {
            bill_of_sale_id: props.bosId,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        }
        console.log("request======", request);

        API.post("bosarbstatusview/condition", request).then(response => {
            console.log("view Identify", response.data.data.length)
            setComments(response.data.data[0]?.arb);
            setArb(response.data.data[0]?.arb_status);
        });
    }
    useEffect(() => {
        viewRegistration();

    }, []);
    // const viewRegistration= () =>{
    //     let request ={
    //       bill_of_sale_id: props.bosId,
    //        }
    //        console.log("request======", request);

    //   API.post("bosarbstatusview/billofsaleCondition",request).then(response=>{
    //         console.log("view Identify", response.data.data.length)
    //         setComments(response.data.data[0]?.arb);
    //         setArb(response.data.data[0]?.arb_status);
    //     });
    // }

    // useEffect(() => {
    //     viewRegistration();

    //   }, []);
    const valueComments = ls.get('comments');


    const saveAdd = () => {

        ls.set('comments', comments);


        setCommentsError("")

        if (!comments) {
            setCommentsError("Notes is required")
            return;
        }
        else if (comments.length > 500) {
            setCommentsError("Notes must not exceed 500 characters")
            return;
        }

        const recentlyAddednewvalue = [...notesList, comments]
        setNotesList([...notesList, comments])
        // props.editArb(recentlyAddednewvalue)

        // setComments(" ")
        // setTogglePopupOpen(false)
        console.log("notesList======", notesList)
        console.log("comments======", comments)
        console.log("recentlyAddednewvalue item======", recentlyAddednewvalue)

    }

    return (
        <Modal show={true} onHide={props.toggle} centered>
            <Modal.Header className="Terms-login">
                <Modal.Title>View Arbitary</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h5 className="text-color mb-4 text-center">Arb</h5>
                <div className='row'>
                    <div className="col-lg-6 view-arb">
                        <input className="form-check-input" type="radio" checked={arb === "Arbirtraon"} id="Arbirtraon" />
                        <label className="form-check-label" htmlFor="Arbirtraon">Arbirtraon</label>
                    </div>
                    <div className="col-lg-6 view-arb">
                        <input className="form-check-input" type="radio" checked={arb === "Sold"} id="Sold" />
                        <label className="form-check-label" htmlFor="Sold">Sold</label>
                    </div>
                </div>
                <div className='row'>
                <div className="col-lg-6 view-arb">
                    <input className="form-check-input" type="radio" checked={arb === "Reject"} id="Reject" />
                    <label className="form-check-label" htmlFor="Reject">Reject</label>
                </div>
                <div className="col-lg-6 view-arb">
                    <input className="form-check-input" type="radio" checked={arb === "pending"} id="Pending" />
                    <label className="form-check-label" htmlFor="Pending">Pending</label>
                </div>
                </div>
                <label htmlFor="buyer" className="form-label">Description</label>
                <textarea className="form-control mt-3" placeholder="" aria-label="default input example" defaultValue={comments} disabled onChange={(e) => setComments(e.target.value)}></textarea>

                <div className="Sellernotes">
                    <Button className="cta-btn" onClick={props.toggle}>Close</Button>
                </div>

            </Modal.Body>
        </Modal>
    );
}
export default ViewArb